export enum DashboardActionType {
    GET_OPERATIONAL_DASHBOARD = 'get_operational_dashboard',
    SET_DASHBOARD_FILTER = 'set_dashboard_filter',
}